import {connect} from 'react-redux';
import ReviewLoader from './ReviewLoader';
import {RouteComponentProps, withRouter} from 'react-router';
import Action from '../../redux/Actions';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import ParamsModel from '../../types/ParamsModel';
import UserModel from '../../types/UserModel';
import Config from '../../globals/Config';

const mapStateToProps = (state: ReduxState, ownProps: RouteComponentProps<ParamsModel> & Record<string, any>) => {
   const routeParams = ownProps.match.params;
   const commentIdFromQueryString = new URLSearchParams(location.search).get('commentid');
   return {
      reviewId: Config.reviewId || routeParams.reviewId,
      versionNumber: Config.versionNumber || parseInt(routeParams.versionNumber, 10) || 1,
      commentId: routeParams.commentId || commentIdFromQueryString || '',
      comments: state.comments,
      currentUser: state.currentUser || {} as UserModel,
      player: state.player,
      mostRecentCommentUpdate: state.mostRecentCommentUpdate,
      currentReviewVersion: state.currentReviewVersion
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>) => {
   return {
      setPageIsLoading: (isLoading: boolean) => {
         dispatch(Action.setPageIsLoading(isLoading));
      },
      resetReview: () => {
         dispatch(Action.resetReview());
      },
      setSelectedComment: (commentId: string) => {
         dispatch(Action.setSelectedComment(commentId));
      },
      setReviewId: (reviewId: string, versionNumber: number) => {
         dispatch(Action.setReviewId(reviewId, versionNumber));
      }
   };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReviewLoader));
